import { ReactNode } from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'

import { Text, Icon, Card, CardColors, Badge } from '@/ui'
import { TypographyStyles } from '@/styles'

export const SeparateStep = ({
  stepNumber,
  title,
  content,
  icon,
}: {
  stepNumber: string
  title: string
  content: ReactNode
  icon?: IconDefinition
}) => {
  return (
    <Card color={CardColors.LEVEL_1} className="w-full">
      <div className="flex flex-row items-center gap-2">
        <Badge size="sm" color="olive">
          {stepNumber}
        </Badge>
        <Text variant={TypographyStyles.H3}>{title}</Text>
      </div>
      <div className="flex-1">{content}</div>
      {icon && (
        <div className="w-6 flex-shrink-0 flex justify-end">
          <Icon icon={icon} color="gray" size="2x" />
        </div>
      )}
    </Card>
  )
}
